export const HOME = {
  emergentLink: "home-emergent-link",
  ctaCreateMemorial: "home-cta-create-memorial",
  ctaSendEcard: "home-cta-send-ecard",
  ctaAdminLogin: "home-cta-admin-login",
  navBrand: "nav-brand",
};

export const MEMORIAL = {
  petNameInput: "memorial-pet-name-input",
  petTraitsInput: "memorial-pet-traits-input",
  petMemoryInput: "memorial-pet-memory-input",
  petSpeciesInput: "memorial-pet-species-input",
  sceneryPromptInput: "memorial-scenery-prompt-input",
  generateSceneryBtn: "memorial-generate-scenery-btn",
  generatePoemBtn: "memorial-generate-poem-btn",
  modelGemini: "memorial-model-gemini",
  modelOpenai: "memorial-model-openai",
  saveBtn: "memorial-save-btn",
  shareBtn: "memorial-share-btn",
  resultPoem: "memorial-result-poem",
  resultImage: "memorial-result-image",
  shareLink: "memorial-share-link",
};

export const ECARD = {
  recipientNameInput: "ecard-recipient-name-input",
  recipientEmailInput: "ecard-recipient-email-input",
  senderNameInput: "ecard-sender-name-input",
  petNameInput: "ecard-pet-name-input",
  messageInput: "ecard-message-input",
  templateSelect: "ecard-template-select",
  sendBtn: "ecard-send-btn",
  createLinkBtn: "ecard-create-link-btn",
  shareLink: "ecard-share-link",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  navDesigns: "admin-nav-designs",
  navMemorials: "admin-nav-memorials",
  navEcards: "admin-nav-ecards",
  designsList: "admin-designs-list",
  memorialsList: "admin-memorials-list",
  ecardsList: "admin-ecards-list",
};
